export default function ($transitions, lodash, $state, $window, $location, AuthService, PrivilegeService, AuthResource) {
    const gaCode = SEED_CORE.ENV.GA_CODE;
    const TYPE_SUPERSEDED = 2;
    const TYPE_IGNORED = 5;

    if (gaCode) {
        $window.ga('create', gaCode, 'auto');
    }

    $transitions.onStart({}, ($transition) => {
        const params = $transition.params();
        const toParams = params.toParams;

        const company = toParams && toParams.company ? toParams.company : params.company;

        const canAccess = lodash.get($transition.$to(), 'data.canAccess');
        if (canAccess && !canAccess(AuthService, PrivilegeService)) {
            if ($transition.$to().name !== 'unauthorized.login') {
                $state.go('unauthorized.login', {
                    company,
                    toState: $transition.$to().name,
                    toParams: angular.copy(toParams)
                });
            }
            else {
                $state.go('home');
            }
        }
    });

    /**
     * https://ui-router.github.io/ng2/docs/2.0.0/enums/transition.rejecttype.html - error types
     * @param error
     */
    const throwError = (error) => {
        if (error.type === TYPE_IGNORED || error.type === TYPE_SUPERSEDED) {
            return;
        }

        console.error('error', error);
    };

    $transitions.onError({}, ($transition) => {
        const error = $transition.error();

        throwError(error);
    });

    $transitions.onSuccess({}, () => {
        if (AuthService.isLoggedIn()) {
            AuthResource.renewToken();
        }

        // scrollingElement is not supported in ie
        if ($window.document.scrollingElement) {
            $window.document.scrollingElement.scrollTop = 0;
        }

        if (gaCode) {
            $window.ga('send', 'pageview', $location.absUrl());
        }
    });

    // this will rewrite default state handler in order for transition error not to be console.error in certain cases
    $state.defaultErrorHandler(($error) => {
        if ($error.type && ($error.type === TYPE_IGNORED || $error.type === TYPE_SUPERSEDED)) {
            return;
        }

        if ($error instanceof Error && $error.stack) {
            console.error($error);
            console.error($error.stack);
        }
        else {
            console.error($error);
        }
    });
}



// WEBPACK FOOTER //
// ./src/app/runs/routing/index.js